module.exports = __webpack_public_path__ + "img/52f4242e3e33300e3b5706a5d8860e34.png";